import { render, staticRenderFns } from "./ProbniOdgovorSingle.vue?vue&type=template&id=9a105cb4&scoped=true&"
import script from "./ProbniOdgovorSingle.vue?vue&type=script&lang=js&"
export * from "./ProbniOdgovorSingle.vue?vue&type=script&lang=js&"
import style0 from "./ProbniOdgovorSingle.vue?vue&type=style&index=0&id=9a105cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a105cb4",
  null
  
)

export default component.exports